(function () {
	function handleTopbarSlider() {
		const slides = document.querySelectorAll(".swiper-slide.richtext");

		slides.forEach((slide) => {
			const contentDiv = slide.querySelector(".topbar-content");
			if (!contentDiv) return;

			// Check early access first (higher priority)
			const isEarlyAccess = localStorage.getItem("EarlyAccess") === "true";
			if (isEarlyAccess) {
				const earlyAccessDiv = slide.querySelector(".topbar-early-access");
				if (earlyAccessDiv) {
					contentDiv.innerHTML = earlyAccessDiv.innerHTML;
					return;
				}
			}
		});
	}

	handleTopbarSlider();
	window.addEventListener("storage", handleTopbarSlider);
	document.addEventListener("DOMContentLoaded", handleTopbarSlider);
	document.addEventListener("renderedFullSections", handleTopbarSlider);
})();
